import { Button, Footer, Popover, PopoverAnchor, Portal, stopEvent, useVisibility } from '@fold-dev/core'
import React from 'react'
import { UserSelect, UserSelectUser } from './user-select'
import { Users } from './users'

export type UserButtonProps = {
    users: UserSelectUser[]
    onAdd?: (user: UserSelectUser) => void
    onDelete?: (user: UserSelectUser) => void
    portal?: any
    disabled?: boolean
    userSelectProps?: any
    anchor?: any
}

export const UserButton = (props: UserButtonProps) => {
    const { users, onAdd, onDelete, portal, anchor, disabled, userSelectProps = {} } = props
    const { visible, show, hide } = useVisibility()

    return (
        <Popover
            portal={portal}
            width={300}
            preferredHorizontalAnchor={anchor ? anchor.horizontal : undefined}
            preferredVerticalAnchor={anchor ? anchor.vertical : undefined}
            border="none"
            isVisible={visible}
            onDismiss={hide}
            content={
                <div
                    onMouseDown={stopEvent}
                    onClick={stopEvent}>
                    <UserSelect
                        {...userSelectProps}
                        users={users}
                        onAdd={onAdd}
                        onDelete={onDelete}
                        onDismiss={hide}
                        // footer={
                        //     <Footer
                        //         p="0.5rem 0.5rem 0 0"
                        //         justifyContent="flex-end">
                        //         <Button
                        //             size="sm"
                        //             variant="accent"
                        //             onClick={hide}>
                        //             Okay
                        //         </Button>
                        //     </Footer>
                        // }
                    />
                </div>
            }>
            <div
                onMouseDown={stopEvent}
                className="f-row"
                style={{
                    pointerEvents: disabled ? 'none' : undefined,
                    //opacity: disabled ? 1 : undefined,
                }}>
                <Users
                    disabled={disabled}
                    users={users}
                    onClick={show}
                />
            </div>
        </Popover>
    )
}
